import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeWorkersCompensationReport extends Layout {
    checkboxExcludeNonTaxable: Checkbox;
    checkboxIncludeCrossYear: Checkbox;
    checkboxIncludeSettlementHistory: Checkbox;
    checkboxIncludeSsn: Checkbox;
    excludabletextboxDivisions: ExcludableTextbox;
    excludabletextboxJobClasses: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    excludabletextboxTerminals: ExcludableTextbox;
    sourceOfficeWorkersCompensation: DataSource;
    switchReportType: Switch;
    textboxCheckDateRange: Textbox;
}
